<template>
  <div id="app" v-if="loginOK">
    <Header v-if="!this.$route.params.viewid" />
    <div class="toast hide" id="Toast1"></div>
    <router-view />
  </div>
  <Loading v-else title="Connecting to Device Monitor" />
</template>
<style lang="scss">
@import "@/assets/styles/global.scss";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  height: max-content;
  display: flex;
  flex-direction: column;
}
</style>
<script>
import Header from "@/components/parts/Header.vue";
import loginApi from "@/plugin/login-api";
import Loading from "@/components/parts/Loading.vue";

export default {
  components: {
    Header,
    Loading
  },
  data() {
    return {
      loginOK: false
    };
  },
  sockets: {
    connect() {
      console.log("socket connected");
    },
    loginOK() {
      this.loginOK = true;
    },
    changeTheme(val) {
      this.$store.state.theme = val;
    }
  },
  created() {
    this.checkQuery();
    this.checklogin();
  },
  methods: {
    geturl() {
      return btoa(document.URL);
    },
    clearLogin() {
      this.$store.state.account = null;
      delete localStorage.token;
      this.$router.go("/");
    },
    setAccountData(dataextract) {
      if (dataextract.data.id) {
        console.log(dataextract);
        console.log(localStorage.token);
        this.$store.state.account = dataextract.data;
      } else {
        this.clearLogin();
      }
    },
    checkQuery() {
      if (this.$route.query.auth) {
        localStorage.token = this.$route.query.auth;
        window.location = process.env.NODE_URL;
      }
    },
    checklogin() {
      if (!localStorage.token && this.$router.path !== "/") {
        window.location = "https://auth.infrequent.net/login/" + this.geturl();
        console.log(
          "going here: " + "https://auth.infrequent.net/login/" + this.geturl()
        );
      } else {
        loginApi()
          .post("/login/logged", {})
          .then(response => this.setAccountData(response))
          .catch(() => this.clearLogin());
      }
    }
  }
};
</script>
